// extracted by mini-css-extract-plugin
export default {"backgroundImageBot":"BackgroundImageDayReportBotPosition_backgroundImageBot__xBVUP"};